import { action, makeObservable, observable } from "mobx";
import { PipelineData } from "../../../features/workspace/pipeline/Pipeline";

export type GalleryItem = {
  images: string[];
  name: string;
  modelVersion?: string;
  mainImage: string
  status?: 'competed' | 'pending' | 'starting' | 'ending';
}

export type PrivateModel = {
  record_id: number;
  version: string;
  status: string;
  name: string;
  data: {
    images: { url: string, preview: string }[];
    name: string;
  };
}

export type GalleryModel = {
  images: { url: string, preview: string }[];
  previewHdrl: string;
  enhancedHdrlFile: string;
  modelVersion?: string;
  loraPath?: string;
}

export enum MODE {
  GALLERY,
  SELECT_MODE,
  PIPELINES,
  DEPTH_MAP,
  ENLARGE,
  RELIGHT,
  UPSCALE,
  UPSCALE_V2,
  UPSCALE_FREEPIK,
  SELECT_ANGLE,
  CHANGE_BACKGROUND,
  SELECT_ANGLE_VIEWER,
  IMPORT_CAR,
  IMG2IMGFLUX,
  GEN_SIMILAR,
  PICK_IMAGE,
  SELECTED_MODEL,
  ADD_CUSTOM_MODEL,
  IMAGE_360,
  IMAGE_360_DEEPIX,
  IMAGE_360_BLOCKADE,
  ANY_CUSTOM_MODEL,
  FEATURED,
  CONTROLNET_PIPELINE,
  CONTROLNET_PIPELINE_RAV4,
  CONTROLNET_PIPELINE_V2,
  PLACE_CAR_V2,
  IMG2IMGV2,

  PLACE_CAR_V3_IMAGE,
  PLACE_CAR_V3_REDUX,
  PLACE_CAR_V4,

  FIX_RIMS,
  REMOVE_OBJECT,
  FILL_CAR,

  SHUTTER_IMAGE_360,
  SHUTTER_IMAGE_HDR,

  GPT_ENHANCE
}

export enum MODE_2 {
  THREE_D = 1,
  PLACE_CAR = 2,
  CAR_LORA = 3,
  VARIATIONS = 4,
  AI_RETOUCH = 5,
  INPAINT = 6,

  FIX_RIMS = 7,
  REMOVE_OBJECT = 8,
  FILL_CAR = 9,
  SHUTTER_IMAGE_360 = 10,
  SHUTTER_IMAGE_HDR = 11,
  ENLARGE = 12,
  UPSCALE = 13,
  UPSCALE_V2 = 14,
  UPSCALE_FREEPIK = 15,
  IMG2IMGFLUX = 16,
  PLACE_CAR_V4 = 17,
  PLACE_CAR_V2 = 18,
  KLING = 19,
  PLACE_CAR_K = 20,
  VEO = 21,
  HAILUO = 22,
  AI_RETOUCH_2 = 23,
  SEEDANCE = 24,
  AI_RETOUCH_3 = 25,
  PLACE_CAR_NANO_BANANA = 26,
  UPSCALE_HDR_V1 = 27,
  WAN = 28,
  THREE_D_HDR = 29,
  CAMERA_ROTATE = 30,
  WORKSPACE_AIRETOUCH = 31,
}
export class SpaceStore {
  // ux heplers

  @observable ratio: string = '4:3';
  @observable prompt: string = '';
  @observable carImg: string = '';
  @observable negativePrompt: string = '';
  @observable secondLoraName: string = '';
  @observable secondLoraDisplayName: string = '';
  @observable moodLora: string = '';
  @observable cfg: number = 3.5;
  @observable steps: number = 50;
  @observable locationScale: number = 1;
  @observable secondLoraScale: number = 1;
  @observable carColor: string = '#BFBFBF';
  @observable carPerspectives: string[] = [
    'Front View',
    'Rear View',
    'Side View (Left)',
    'Side View (Right)',
    'Front 3/4 View (Left)',
    'Front 3/4 View (Right)',
    'Rear 3/4 View (Left)',
    'Rear 3/4 View (Right)'
  ]

  @observable gptImageParam: string = '';
  @observable billingModalOpen: boolean = false;
  @observable billingAccessModalOpen: boolean = false;
  @observable buyCreditsModalOpen: boolean = false;

  @observable selectedModel: GalleryItem | null = null
  @observable selectedImage: string | null = null
  @observable influnceImage: string | null = null
  @observable privateModels: PrivateModel[] = []
  @observable gallery: GalleryModel[] = []
  //  {
  //   images: [
  //     "https://cdn.maground.ai/eu/images/7ws63p2g9sa8flnfibkum9xu3rq2ea.png",
  //     "https://cdn.maground.ai/eu/images/a2avjgtror075xzomxz0flsasulcgu.png",
  //     "https://cdn.maground.ai/eu/images/f7dbmnuv0qoeh707mpadgrtkjckcv0.png",
  //     "https://cdn.maground.ai/eu/images/iao9njtamo7sj2b4wijda1jq2ob34f.png",
  //     "https://cdn.maground.ai/eu/images/bhuan6tt7rqbl118tufxaa7k2ye8jj.png",
  //     "https://cdn.maground.ai/eu/images/n7m3wbmda8u1v40rrxki5pz3kil4ul.png",
  //     "https://cdn.maground.ai/eu/images/cm254055u9btxeup761lxewlwgiiw1.png",
  //     "https://cdn.maground.ai/eu/images/zad9bw1dmbwz5f34wcq8y8geyonlvx.png",
  //     "https://cdn.maground.ai/eu/images/m8ymt17ua7kcylpo4d2eyq2hffxzwz.png"
  //   ],
  //   mainImage: "https://cdn.maground.ai/eu/images/7ws63p2g9sa8flnfibkum9xu3rq2ea.png",
  //   name: "ma-MAG_14358",
  //   modelVersion: '',
  //   status: 'competed'
  // }

  @observable pipelines: {
    record_id: number
    data: PipelineData
    status: 'pending' | 'completed' | 'ending' | 'failed';
  }[] = []

  @observable latestCustomModelsRun: {
    srcset: string[]
    jobId: string
  }[] = []
  @observable big: boolean = false
  @observable mode: MODE = MODE.GALLERY
  @observable mode2: MODE_2 | null = null
  @observable rating: number = 0

  // References for starting node - now stored in localStorage
  @observable referenceImages: {
    id: string;
    url: string;
    name: string;
    type: 'upload' | 'gallery';
    timestamp: number;
  }[] = []


  constructor() {
    makeObservable(this);
    this.loadReferenceImagesFromStorage();
  }

  // Load reference images from localStorage on initialization
  private loadReferenceImagesFromStorage() {
    try {
      const stored = localStorage.getItem('magai_reference_images');
      if (stored) {
        this.referenceImages = JSON.parse(stored);
      }
    } catch (error) {
      console.error('Failed to load reference images from localStorage:', error);
    }
  }

  // Save reference images to localStorage
  private saveReferenceImagesToStorage() {
    try {
      localStorage.setItem('magai_reference_images', JSON.stringify(this.referenceImages));
    } catch (error) {
      console.error('Failed to save reference images to localStorage:', error);
    }
  }

  @action
  setPipelines = (model: {
    record_id: number
    data: PipelineData
    status: 'pending' | 'completed' | 'ending' | 'failed';
  }[]) => {
    this.pipelines = model;
  }
  
  @action
  setCarImg = (url: string) => {
    this.carImg =url 
  }

  @action
  setSelectedModel = (model: {
    model: GalleryItem | null

  }) => {
    if (model.model) {

      this.selectedImage = null
      this.selectedModel = model.model;
      this.prompt = ''
    } else {
      this.selectedModel = null
      this.selectedImage = null
      this.mode2 = null
    }
  }

  @action
  setSelectedImage = (model: {
    src: string | null
  }) => {
    this.selectedModel = null
    this.selectedImage = model.src
  }
  @action
  setInfluenceImage = (model: {
    src: string | null
  }) => {
    this.influnceImage = model.src
  }

  @action
  setCfg = (val: number) => {
    this.cfg = val;
  }
  @action
  setSteps = (val: number) => {
    this.steps = val;
  }

  @action
  setSecondLora = (model: {
    label: string
    value: string
  } | null) => {
    if (model) {
      this.secondLoraName = model.value;

      this.secondLoraDisplayName = model.label;
    } else {
      this.secondLoraName = '';
      this.secondLoraDisplayName = '';
    }
  }

  @action
  setLocationScale = (val: number) => {
    this.locationScale = val;
  }

  @action
  setBillingAccessModalOpen = (val: boolean) => {
    this.billingAccessModalOpen = val;
  }
  @action
  setBuyCreditsModalOpen = (val: boolean) => {
    this.buyCreditsModalOpen = val;
  }
  // @action
  // setBillingModalOpen = (val: boolean) => {
  //   this.billingModalOpen = val;
  // }

  @action
  setSecondLoraScale = (val: number) => {
    this.secondLoraScale = val;
  }
  @action
  setCarColor = (val: string) => {
    this.carColor = val;
  }
  @action
  setCarPerspectives = (val: string[]) => {
    this.carPerspectives = val;
  }

  @action
  addPipeline = (model: {
    record_id: number
    data: PipelineData
    status: 'pending' | 'completed' | 'ending' | 'failed';
  }) => {
    console.log(model)
    this.pipelines = [model, ...this.pipelines];
  }

  @action
  setLatestCustomModelsRun = (model: {
    jobId: string
  }) => {
    this.latestCustomModelsRun = [...this.latestCustomModelsRun, {
      srcset: [],
      jobId: model.jobId
    }]
  }

  @action
  setBig = (value: boolean) => {
    this.big = value;
  }
  @action
  setRating = (rating: number) => {
    this.rating = rating;
  }

  @action
  setMode2 = (value: MODE_2 | null) => {
    this.mode2 = value;
  }

  @action
  setMode = (mode: MODE) => {
    this.mode = mode;
  }

  @action
  setGptImageParam = (image: string) => {
    this.gptImageParam = image;
  }

  @action
  clearLatest = () => {
    this.latestCustomModelsRun = [];
  }

  @action
  updatePipeline = (data: {
    data: PipelineData
    status: 'pending' | 'completed' | 'ending' | 'failed';
  }, jobId: string) => {
    const index = this.pipelines.findIndex((p) => p.data.jobId === jobId)
    if (index !== -1) {
      this.pipelines[index] = {
        ...this.pipelines[index],
        status: data.status,
        data: data.data,
      }

      // const latestIndex = this.latestCustomModelsRun.findIndex((p) => p.jobId === jobId)
      // if (latestIndex !== -1) {
      //   this.latestCustomModelsRun[latestIndex] = {
      //     srcset: data.data.params?.srcset,
      //     jobId
      //   }
      // }
    }
  }


  @action
  setRatio = (ratio: string) => {
    this.ratio = ratio
  }
  @action
  setPrompt = (prompt: string) => {
    this.prompt = prompt
  }
  @action
  setNegativePrompt = (prompt: string) => {
    this.negativePrompt = prompt
  }

  @action
  setPrivateModels = (models: PrivateModel[]) => {
    this.privateModels = models;
  }

  @action
  setGallery = (items: GalleryModel[]) => {
    this.gallery = items;
  }

  // Reference management actions - updated for localStorage
  @action
  addReferenceImage = (reference: {
    id: string;
    url: string;
    name: string;
    type: 'upload' | 'gallery';
  }) => {
    const newReference = {
      ...reference,
      timestamp: Date.now()
    };
    this.referenceImages = [...this.referenceImages, newReference];
    this.saveReferenceImagesToStorage();
  }

  @action
  removeReferenceImage = (id: string) => {
    this.referenceImages = this.referenceImages.filter(ref => ref.id !== id);
    this.saveReferenceImagesToStorage();
  }

  @action
  clearReferenceImages = () => {
    this.referenceImages = [];
    this.saveReferenceImagesToStorage();
  }

  // Legacy methods for backward compatibility
  @action
  addReference = (reference: {
    id: string;
    url: string;
    name: string;
    type: 'upload' | 'gallery';
  }) => {
    this.addReferenceImage(reference);
  }

  @action
  removeReference = (id: string) => {
    this.removeReferenceImage(id);
  }

  @action
  clearReferences = () => {
    this.clearReferenceImages();
  }

}